import { render, staticRenderFns } from "./QuoteOld.vue?vue&type=template&id=d4d3ed0e"
import script from "./QuoteOld.vue?vue&type=script&lang=js"
export * from "./QuoteOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports